import Template from './DisplaysView.njk';
import Marionette from "backbone.marionette";
import Xola from "../../Xola";
import { Cookie } from "../../application/Cookie";
import { DisplayListView } from "../components/DisplayListView";
import "./DisplaysView.less";

export const DisplaysView = Marionette.View.extend({
  template: Template,
    className: "DisplaysView",
    events: {
        'click button': 'onCancel'
    },

    regions: {
        displayList: '.region-display-list'
    },

    onRender() {
        var displayCollectionView = new DisplayListView({collection: this.collection});
        this.showChildView("displayList", displayCollectionView);
    },

    onCancel() {
        Xola.logout();
        Cookie.setApiKey(null);

        this.trigger('display.cancel');
    },

    onChildviewChildviewClick(childView) {
        this.trigger('display.select', childView.model);
    }
});




// WEBPACK FOOTER //
// ./src/js/view/pages/DisplaysView.js